module.exports = __webpack_public_path__ + "source/img/speeching.4fc18af8.svg";